import React, {Component} from 'react'
import {
    Card,
    Table,
    Button,
    Tag,
    Modal,
    Form,
    Input,
    TreeSelect,
    notification,
    Radio,
    InputNumber,
    Select,
    Pagination, Drawer, Tooltip,Badge
} from 'antd';
import UserDataRight from '../../components/DataRight/UserDataRight'
import {getMallResourceList,saveMallResource} from '../../request'
import * as Icon from '@ant-design/icons';
import IconFun from '../../public/icon'

const { Option } = Select;
const { TreeNode } = TreeSelect;

let columnsKey = {
    resourceName: '名称',
    resourceCode: '标识',
    resourceOrder: '排序',
    resourceIcon: '图标',
    resourceIconExt: '外部图标',
    resourceType: '类型',
    resourceHtmlUrl: '路由',
    roleNames: '角色权限',
    userNames: '用户权限',
    status: '状态',
    actions: '操作'
}
const layout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 18,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 6,
        span: 18,
    },
};
const initItemDetail = {
    resourceHtmlUrl: "",
    resourceIcon: "",
    resourceIconExt: "",
    resourceId: '',
    resourceName: "",
    resourceCode: "",
    resourceOrder: 1,
    resourceParentId: '',
    resourceType: 1,
    resourceUrl: "",
    status: 1,
}
export default class sysResource extends Component {
    userDataRight = React.createRef();
    state = {
        dataSource:[],
        columns:[],
        pagination: {
            current: 1,
            pageSize: 50,
        },
        initItemDetail,
        visible:false,
        loading:false,
        dataRightVisible:false,
        currentResource:{}
    };
    createColumns = (createKeys)=>{
        let columns = Object.keys(createKeys).map(item=>{
            let initObj = {
                title:createKeys[item],
                dataIndex:item,
                key:item,
            }
            if(item=='resourceIcon'){
                return {
                    ...initObj,
                    render:(text, record, index)=>{
                            if(text&&text.indexOf('el-')<=-1) {
                                try{
                                    return <IconFun icon={text} />
                                    // React.createElement( Icon && Icon[text],{
                                    //             style:{fontSize:'16px'}
                                    //         })
                                }catch (e) {
                                    console.log(e)
                                    return text
                                }
                            }else{
                                return text
                            }

                    }
                }
            }else if(item=='resourceOrder'){
                return {
                    ...initObj,
                    render:(text,record,index)=>{
                        return text
                    }
                }
            }else if(item=='resourceType'){
                return {
                    ...initObj,
                    render:(text,record,index)=>{
                        switch (text){
                            case 1:
                                return <Tag color="blue">菜单</Tag>
                            case 2:
                                return <Tag color="magenta">资源</Tag>
                            case 3:
                                return <Tag>按钮</Tag>
                            default:
                                return ''
                        }
                    }
                }
            }else if(item=='status'){
                return {
                    ...initObj,
                    render:(text,record,index)=>{
                        return  text==1?<Icon.CheckCircleOutlined style={{ fontSize: '16px', color: 'green' }}/>:<Icon.CloseCircleOutlined style={{ fontSize: '16px', color: 'red' }} />
                    }
                }
            }else if(item=='roleNames'){
                return {
                    ...initObj,
                    render:(text,record,index)=>{
                        return  (
                            <>
                                {
                                    record.resourceParentId!=0&&record.resourceType==1&&!record.children?
                                        <Tooltip title={text}>
                                            <Badge style={{cursor:'pointer'}}  count={'查看角色'} color="#faad14" />
                                        </Tooltip>
                                        :''
                                }
                            </>
                        )
                    }
                }
            }else if(item=='userNames'){
                return {
                    ...initObj,
                    render: (text, record, index) => {
                        return (
                            <>
                                {
                                    record.resourceParentId != 0 && record.resourceType == 1 && !record.children ?
                                        <Tooltip title={text}>
                                            <Badge style={{cursor: 'pointer'}} count={'查看用户'} color="#52c41a"/>
                                        </Tooltip>
                                        : ''
                                }
                            </>
                        )
                    }
                }
            }else if(item=='actions'){
                return {
                    ...initObj,
                    fixed:'right',
                    width:120,
                    render:(text, record, index)=>{
                        console.log( record.children)
                        return (
                            <>
                                <Button type="link" size="small" onClick={()=>(this.handleItemEdit(record))}>修改</Button>
                                {
                                    record.resourceParentId!=0&&record.resourceType==1&&!record.children?
                                        <Button type="link" size="small" onClick={()=>(this.handleOpenRight(record))}>权限</Button>
                                    :''
                                }

                            </>
                        )
                    }
                }
            }else{
                return initObj
            }
        })
        this.setState({
            columns:columns
        })
    }
    // 上级菜单最多可选到第 4 级（即新建菜单最多落在第 5 级）
    MAX_PARENT_MENU_LEVEL = 4;

    // 后端返回的是完整嵌套树；这里递归清洗（去掉空 children），不再按固定层级截断
    normalizeTreeData = (list)=>{
        if(!Array.isArray(list)) return [];
        return list.map(item=>{
            const {children,...rest} = item
            const node = {...rest}
            if(Array.isArray(children)&&children.length>0){
                node.children = this.normalizeTreeData(children)
            }
            return node
        })
    };

    // 编辑时不允许把「上级菜单」选成当前菜单自己或自己的子孙，避免形成父子环
    collectSelfAndDescendantIds = (list, resourceId)=>{
        const ids = []
        const walk = (nodes, inSubtree)=>{
            (nodes||[]).forEach(node=>{
                const isTarget = node.resourceId===resourceId
                if(inSubtree||isTarget){
                    ids.push(node.resourceId)
                }
                walk(node.children, inSubtree||isTarget)
            })
        }
        walk(list, false)
        return ids
    };

    // 上级菜单下拉：递归渲染，最多到第 4 级；按钮类资源若无子节点则不作为上级候选
    renderParentMenuNodes = (list, level, disabledIds)=>{
        if(!Array.isArray(list)||level>this.MAX_PARENT_MENU_LEVEL) return [];
        return list
            .filter(item=>{
                const hasChildren = Array.isArray(item.children)&&item.children.length>0;
                return item.resourceType!==2||hasChildren;
            })
            .map(item=>{
                return (
                    <TreeNode value={item.resourceId}
                              key={item.resourceId}
                              title={item.resourceName}
                              disabled={disabledIds.includes(item.resourceId)}>
                        {this.renderParentMenuNodes(item.children, level+1, disabledIds)}
                    </TreeNode>
                )
            })
    };
    initTableDataList = (resourceName='',pagination={})=>{
        this.setState({ loading: true });
        getMallResourceList({
            currentPage:pagination.current,
            pageSize:pagination.pageSize,
            resourceName:resourceName}).
        then(res=>{
            this.setState({
                dataSource:this.normalizeTreeData(res.list),
                loading:false,
                pagination:{
                    ...pagination,
                    total:res.total
                }
            })
        })
    }
    handleItemEdit = (item)=>{
        let {children,...detail} = item
        this.setState({
            visible:true,
            initItemDetail:detail
        })
    }
    handleOpenRight = (record)=>{
        console.log( record)
        this.setState({
            currentResource:{
                resourceId:record.resourceId,
                resourceName:record.resourceName
            }
        })
        this.userDataRight.current.openUserRight(record.resourceId)

    }
    handleSubmit = (values)=>{
        const {pagination,initItemDetail} = this.state;
        values.resourceId = initItemDetail.resourceId
        saveMallResource(values).
        then(res=>{
            notification.success({
                message: '操作成功',
            });
            this.setState({
                visible:false,
            })
            this.initTableDataList('',pagination)

        })
    }
    handlePageChange = (current,pageSize)=>{
        this.initTableDataList('',{current,pageSize})
    }
    handleCloseModel = ()=>{
        this.setState({
            visible:false,
        })
    }
    componentDidMount(){
        const {pagination} = this.state;
        this.createColumns(columnsKey);
        this.initTableDataList('',pagination)
    }
    render() {
        const { dataSource,columns, visible, loading,pagination,initItemDetail } = this.state;
        const disabledParentIds = initItemDetail&&initItemDetail.resourceId
            ? this.collectSelfAndDescendantIds(dataSource,initItemDetail.resourceId)
            : [];

        return (
            <div>
                <Card title="资源管理" bordered={false}>
                    <Button type="primary" style={{marginBottom:'20px'}} onClick={()=>this.handleItemEdit(initItemDetail)}>新增</Button>

                    <Table
                        bordered
                        size="small"
                        pagination={false}
                        dataSource={dataSource}
                        columns={columns}
                        rowKey={record=>record.resourceId}
                        loading={loading}
                        transformCellText={(text)=>{
                            console.log('t',text)
                            return ''
                        }}
                        expandable={{
                            rowExpandable:(record)=>console.log(record),
                            indentSize:40
                        }}/>
                    <Pagination style={{float:'right',margin:'16px 0'}} hideOnSinglePage={true} size="small" {...pagination} onChange={this.handlePageChange}/>

                </Card>
                <Modal
                    title="修改"
                    open={visible}
                    destroyOnClose={true}
                    onCancel={this.handleCloseModel}
                    footer={null}
                >
                    <Form
                        {...layout}
                        name="basic"
                        labelAlign="right"
                        preserve={false}
                        initialValues={this.state.initItemDetail}
                        onFinish={this.handleSubmit}
                    >
                        <Form.Item
                            label="类型"
                            labelAlign="right"
                            name="resourceType"
                        >
                            <Radio.Group value={this.state.initItemDetail.resourceType}>
                                <Radio value={1}>菜单</Radio>
                                <Radio value={2}>按钮</Radio>
                                <Radio value={3}>基础数据</Radio>
                                <Radio value={4}>账表</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            label="名称"
                            name="resourceName"
                            rules={[{ required: true, message: '请输入菜单名称' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="上级菜单"
                            name="resourceParentId"
                            rules={[{ required: true, message: '请选择上级菜单' }]}
                        >
                            <TreeSelect
                                showSearch
                                filterTreeNode={(inputValue,treeNode)=>{return (treeNode?.title ?? '').toLowerCase().includes(inputValue.toLowerCase()) }}
                                treeLine={{showLeafIcon:false}}
                            >
                                <TreeNode value={0} key={0} title={'一级菜单'} />
                                {this.renderParentMenuNodes(dataSource,1,disabledParentIds)}
                            </TreeSelect>
                        </Form.Item>
                        <Form.Item
                            label="资源Code"
                            name="resourceCode"
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="资源路径"
                            name="resourceHtmlUrl"
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="资源图标"
                            name="resourceIcon"
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="外部图标"
                            name="resourceIconExt"
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="排序"
                            name="resourceOrder"
                        >
                            <InputNumber value={this.state.initItemDetail.resourceOrder} min={1} max={50} />
                        </Form.Item>
                        <Form.Item
                            label="状态"
                            name="status"
                        >
                            <Select style={{ width: '100%' }} value={this.state.initItemDetail.status}>
                                <Option value={1}>有效</Option>
                                <Option value={0}>无效</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item {...tailLayout}>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
                <UserDataRight ref={this.userDataRight}  resourceId={this.state.currentResource.resourceId} />
            </div>
        )
    }
}